import { Injectable } from "@angular/core";
import { Subject } from "rxjs";


@Injectable()
export class RefreshService {
    private refreshSubject = new Subject<string>();
    public refresh$ = this.refreshSubject.asObservable();
    
    triggerRefresh(entityType: string) {
      this.refreshSubject.next(entityType);
    }
}
